import { utils, Sprite } from 'pixi.js';
import { app } from '../app';

export class PhotoOverlay {
    constructor() {
        this.buildOverlay();
    }

    buildOverlay() {
        this.overlay = document.createElement('div');
        this.overlay.style.position = 'fixed';
        this.overlay.style.width = '100%';
        this.overlay.style.height = '100%';
        this.overlay.style.backgroundColor = 'rgba(128, 128, 128, .5)';
        this.overlay.id = 'photo-overlay';
        this.overlay.onclick = this.overlay.ontouchend = () => {
            this.hide();
        };

        this.imgContainer = document.createElement('div');
        this.imgContainer.style.position = 'fixed';
        this.imgContainer.style.top = '50%';
        this.imgContainer.style.left = '50%';
        this.imgContainer.style.transform = 'translate(-50%, -50%)';
        this.overlay.appendChild(this.imgContainer);

        this.displayImg = document.createElement('img');
        this.displayImg.style.maxWidth = '100%';
        this.displayImg.style.height = 'auto';
        this.displayImg.ontouchend = () => {
            event.stopPropagation();
        };
        this.imgContainer.appendChild(this.displayImg);

        this.tutImg = document.createElement('img');
        this.tutImg.style.position = 'fixed';
        this.tutImg.style.top = '75%';
        this.tutImg.style.left = '50%';
        this.tutImg.style.transform = 'translate(-50%, -50%)';
        this.tutImg.style.maxWidth = '100%';
        this.tutImg.style.height = 'auto';
        this.tutImg.ontouchend = () => {
            event.stopPropagation();
        };
        this.imgContainer.appendChild(this.tutImg);
    }

    show(base64) {
        this.displayImg.src = base64;
        document.getElementsByTagName('body')[0].appendChild(this.overlay);

        if (utils.isMobile.any) this.playMobileTut();
        else this.playDesktopTut();
    }

    hide() {
        document.getElementsByTagName('body')[0].removeChild(this.overlay);
    }

    playMobileTut() {
        this.imgs = [
            'tut-mobile-1',
            'tut-mobile-2',
            'tut-mobile-3',
            'tut-mobile-4',
            'tut-mobile-5',
        ];

        this.loopCount = 15;
        this.count = 0;

        this.tutImg.style.display = 'block';
        app.tween(this, {
            loop: this.loopCount,
            onComplete: () => {
                this.tutImg.style.display = 'none';
            }
        }).call(() => {
            if (this.count >= this.imgs.length) this.count = 0;

            let sprite = new Sprite.from(this.imgs[this.count]),
                base64 = app.renderer.plugins.extract.base64(sprite, 'image/png');

            this.tutImg.src = base64;
            this.count++;
        }).wait(750);
    }

    playDesktopTut() {
        this.imgs = [
            'tut-desktop-1',
            'tut-desktop-2'
        ];

        this.loopCount = 6;
        this.count = 0;

        this.tutImg.style.display = 'block';
        app.tween(this, {
            loop: this.loopCount,
            onComplete: () => {
                this.tutImg.style.display = 'none';
            }
        }).call(() => {
            if (this.count >= this.imgs.length) this.count = 0;

            let sprite = new Sprite.from(this.imgs[this.count]),
                base64 = app.renderer.plugins.extract.base64(sprite, 'image/png');

            this.tutImg.src = base64;
            this.count++;
        }).wait(750);
    }
}
